type LogContext = Record<string, unknown>;

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const isDev = import.meta.env.DEV;

const formatPrefix = (scope?: string): string => {
  return scope ? `[${scope}]` : '[app]';
};

const emit = (level: LogLevel, message: string, context?: LogContext | unknown): void => {
  const method =
    level === 'debug' ? console.debug :
    level === 'info' ? console.info :
    level === 'warn' ? console.warn :
    console.error;

  if (context !== undefined) {
    method(message, context);
    return;
  }

  method(message);
};

export const createLogger = (scope?: string) => {
  const prefix = formatPrefix(scope);

  return {
    debug: (message: string, context?: LogContext | unknown) => {
      if (!isDev) return;
      emit('debug', `${prefix} ${message}`, context);
    },
    info: (message: string, context?: LogContext | unknown) => {
      emit('info', `${prefix} ${message}`, context);
    },
    warn: (message: string, context?: LogContext | unknown) => {
      emit('warn', `${prefix} ${message}`, context);
    },
    error: (message: string, context?: LogContext | unknown) => {
      emit('error', `${prefix} ${message}`, context);
    }
  };
};
